import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=4d8a0f4a&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8a0f4a')) {
      api.createRecord('4d8a0f4a', component.options)
    } else {
      api.reload('4d8a0f4a', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=4d8a0f4a&", function () {
      api.rerender('4d8a0f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f1zlIczwxeZa/JS/comp/RatingDisplay.vue"
export default component.exports